import React from "react";
import { livePrefix, prematchPrefix, urls } from "../../Container";
import { classIf } from "../../data/utils";
import { useNavButtons } from "../NavButtonsProvider";
import Link from "../../router/Link";
import { getLabel } from "../../InitData";
import { showLiveSectionOnly } from "../../showLiveSectionOnly";

export default function NavButtonsContainer() {
    const navButtons = useNavButtons();
    const descsByIndex = [getLabel('general.today'), getLabel('general.tomorrow')]
    const isActive = (active) => ("c_5" + classIf(active, 'active'));
    const liveSectionOnly = showLiveSectionOnly();

    return (
        <div className="c_3_2" data-type={liveSectionOnly ? '2' : null}>
            <Link href={`${livePrefix}`} className={isActive}>Live</Link>
            <Link href={`${urls.base}/multilive`} className={isActive} exact>{getLabel('general.multilive')}</Link>
            {!liveSectionOnly &&
                <>
                    <Link href={`${prematchPrefix}/h-1`} className="c_5">+1H</Link>
                    <Link href={`${prematchPrefix}/h-3`} className="c_5">+3H</Link>
                    {navButtons.map((b, i) =>
                        <Link key={b.id} href={`${prematchPrefix}/d-${i + 1}`} className={isActive}>{descsByIndex[i] || `${b.desc} ${b.dateShort}`}</Link>
                    )}
                    <Link href={`${prematchPrefix}`} className={isActive}>{getLabel('general.tutti')}</Link>
                </>
            }
        </div>
    );
}
